export default function formatSize(size) {
  size = Number(size) || 0;
  if (size === 0) {
    return "0.00B";
  }
  var isNegative = size < 0;
  if (isNegative) {
    size = Math.abs(size);
  }
  var arr = ["B", "kB", "MB", "GB", "TB"];
  var i = Math.floor(Math.log(size) / Math.log(1024));
  i = Math.min(i, arr.length - 1);
  var prefix = isNegative ? "-" : "";
  return prefix + (size / Math.pow(1024, i)).toFixed(2) * 1 + arr[i];
}